import React from 'react';

let lastSidebarType = null;

export default class SidebarMenuItem extends React.Component {

    onClick() {
        const ui = APP.uiHandler.ui;
        ui.showSidebar(this.props.name);
    }

    render() {
        const ui = APP.uiHandler.ui;
        const active = ui.state.sidebar.type==this.props.name;
        if (active && lastSidebarType != ui.state.sidebar.type) {
            lastSidebarType = ui.state.sidebar.type;
            APP.model.showDoorsClosed(this.props.doorsClosed);
        }
        return (
            <div className={`${active?"active-menu-item":""} menu-item image-text stop-select`} onClick={() => this.onClick()}>
                <svg className="arrow-tail" viewBox="0 0 100 100" preserveAspectRatio="none">
                    <path d="M 0 0 L 100 50 L 0 100 L 100 100 L 100 0 Z" />
                </svg>
                <svg className="arrow-head" viewBox="0 0 100 100" preserveAspectRatio="none">
                    <path d="M 0 0 L 100 50 L 0 100 Z"/>
                </svg>
                <div className="image no-pointer"><img className="footer-img" src={this.props.image} /></div>
                {this.props.label}
            </div>
        );
    }
}